(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[335],{

/***/ 2860:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(8754);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ FindMe; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./src/components/ui/Container/index.ts
var Container = __webpack_require__(4023);
// EXTERNAL MODULE: ./src/components/ui/NextExternalImage.tsx
var NextExternalImage = __webpack_require__(8834);
// EXTERNAL MODULE: ./src/components/ui/SectionTitle/index.tsx + 1 modules
var SectionTitle = __webpack_require__(6227);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.14/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(9228);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(4309);
;// CONCATENATED MODULE: ./src/components/Index/FindMe/style.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute !important;\n    height: 100%;\n    width: 100%;\n    right: 0;\n    top: 0;\n    img {\n        object-fit: cover;\n    }\n    @media (min-width: 768px) {\n        width: 50%;\n    }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute !important;\n    width: 100%;\n    height: 100%;\n    background: red;\n    top: 0;\n    left: 0;\n    opacity: 0.1;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    a {\n        border: none;\n        height: 52px;\n        width: 135px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: white;\n        margin: 0 10px;\n        margin-top: 20px;\n        img {\n            object-fit: contain;\n        }\n    }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n    min-height: 250px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: white;\n    position: relative;\n    padding: 0px 5rem;\n    background: linear-gradient(\n            rgba(32, 93, 95, 0.95) 0%,\n            rgba(30, 70, 90, 0.95) 100%\n        ),\n        url("https://cdn.zakariabenali.me/images/architecture-bg.webp")\n            no-repeat center;\n    box-shadow: rgb(55 111 116 / 30%) 0px 52px 27px -37px;\n    > * {\n        position: relative;\n    }\n    .map-image {\n        opacity: 0.6;\n    }\n    .section-title {\n        text-align: center;\n    }\n    @media (max-width: 768px) {\n        flex-direction: column;\n        justify-content: center;\n        padding: 2.5rem 2rem;\n    }\n'
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}

const FindMeMap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3decf860-0"
})(_templateObject());
const FindMeBG = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3decf860-1"
})(_templateObject1());
const FindMeButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3decf860-2"
})(_templateObject2());
const FindMeCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3decf860-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/components/Index/FindMe/index.tsx





const FindMe = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "find-me",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindMeCard, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FindMeMap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextExternalImage/* NextExternalImage */.P, {
                            fill: true,
                            src: "map.png",
                            className: "map-image",
                            alt: "Photo of dotted map",
                            sizes: "(max-width:600px) 100vw, 40vw"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                        heading: "Find me on"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindMeButtons, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.fiverr.com/benalizakaria",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextExternalImage/* NextExternalImage */.P, {
                                    height: "20",
                                    width: "68",
                                    src: "fiverr.svg",
                                    alt: "Fiverr Logo"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.upwork.com/freelancers/~010aaf53dde57b55f8",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextExternalImage/* NextExternalImage */.P, {
                                    height: "20",
                                    width: "68",
                                    src: "upwork.svg",
                                    alt: "Upwork Logo"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 3194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ HomeSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3711);


function HomeSeo() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: "Full stack developer and UI/UX Designer",
        description: "A Full stack And UI/UX Designer, Worked on various types of projects and I'm looking to exchange me experience with you",
        canonical: "https://www.zakariabenali.me/",
        openGraph: {
            url: "https://www.zakariabenali.me/",
            images: [
                {
                    url: "".concat("https://cdn.zakariabenali.me", "/images/seo.png"),
                    alt: "An image with some of the main technologies i use"
                }
            ],
            site_name: "Zakariabenali",
            type: "website"
        },
        twitter: {
            handle: "@handle",
            site: "@site",
            cardType: "summary_large_image"
        }
    });
}


/***/ }),

/***/ 3051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.14/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(9228);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(4309);
// EXTERNAL MODULE: ./src/components/ui/animations.ts
var animations = __webpack_require__(954);
;// CONCATENATED MODULE: ./src/components/ui/Button/style.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n            pointer-events: none;\n            &:before {\n                content: "";\n                position: absolute;\n                top: 0;\n                left: 0;\n                width: 100%;\n                height: 100%;\n                background: ',
        ";\n            }\n        "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            background: ",
        ";\n            color: ",
        ";\n        "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 500;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    height: 3.4375rem;\n    width: 10.6875rem;\n    font-size: 1rem;\n    background: ",
        ";\n    color: ",
        ';\n    position: relative;\n    &:after {\n        content: "";\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        border: 2px solid ',
        ";\n        transform: scale(1.2);\n        opacity: 0;\n        transition: 0.3s ease;\n        pointer-events: none;\n    }\n    &:hover:after {\n        transform: scale(1);\n        opacity: 1;\n    }\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n    content: "";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    border: 2px solid\n        ',
        ";\n    border-bottom-color: transparent;\n    transform: translate(-50%, -50%);\n    animation: ",
        " 1s linear infinite;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}


const ButtonContainer = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-9542f99-0"
})(_templateObject2(), (props)=>props.theme.palette.primary.main, (props)=>props.theme.palette.primary.contrastText, (props)=>props.theme.palette.primary.main, (props)=>props.isLoading && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), props.secondary ? props.theme.palette.secondary.main : props.theme.palette.primary.main), (props)=>props.secondary && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), props.theme.palette.secondary.main, props.theme.palette.secondary.contrastText));
const ButtonSpinner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9542f99-1"
})(_templateObject3(), (props)=>props.secondary ? props.theme.palette.secondary.contrastText : props.theme.palette.primary.contrastText, animations/* spinCenter */.jF);

;// CONCATENATED MODULE: ./src/components/ui/Button/index.tsx



const Button = /*#__PURE__*/ react.forwardRef((props, ref)=>{
    const { children , isLoading , secondary , ...rest } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
        ref: ref,
        isLoading: isLoading,
        secondary: secondary,
        className: "button",
        ...rest,
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSpinner, {
                secondary: secondary
            }),
            children
        ]
    });
});


/***/ }),

/***/ 1066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ FadeUp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9256);


const FadeUp = (param)=>{
    let { delay , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .motion.div */ .E.div, {
        initial: "initial",
        animate: "animate",
        variants: {
            initial: {
                opacity: 0,
                y: 50
            },
            animate: {
                opacity: 1,
                y: 0
            }
        },
        transition: {
            delay: delay
        },
        children: children
    });
};
FadeUp.defaultProps = {
    delay: 0
};



/***/ }),

/***/ 8834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ NextExternalImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(959);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3366);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



function NextExternalImage(param) {
    let { src , alt , ...rest } = param;
    const source = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return "".concat("https://cdn.zakariabenali.me", "/images/").concat(src);
    }, [
        src
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        src: source,
        alt: alt,
        ...rest
    });
}


/***/ }),

/***/ 6227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ SectionTitle; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./src/components/ui/FadeUp/index.tsx
var FadeUp = __webpack_require__(1066);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.14/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(9228);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(4309);
;// CONCATENATED MODULE: ./src/components/ui/SectionTitle/style.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-size: 1.25rem;\n    font-weight: 700;\n    text-transform: uppercase;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 1.56rem;\n    font-weight: 700;\n    max-width: 305px;\n    margin-top: 0.3125rem;\n    margin-bottom: 1.25rem;\n    @media (min-width: 600px) {\n        font-size: 2.25rem;\n    }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}

const SubHeading = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4efdaae7-0"
})(_templateObject(), (props)=>props.theme.palette.primary.main);
const Heading = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-4efdaae7-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/components/ui/SectionTitle/index.tsx



const SectionTitle = (param)=>{
    let { heading , subHeading , headingId  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "section-title",
        id: headingId,
        children: [
            subHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUp/* FadeUp */.N, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeading, {
                    children: subHeading
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeUp/* FadeUp */.N, {
                delay: 0.4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                    children: heading
                })
            })
        ]
    });
};


/***/ }),

/***/ 8754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./src/components/ui/Button/index.tsx + 1 modules
var Button = __webpack_require__(3051);
// EXTERNAL MODULE: ./src/components/ui/Container/index.ts
var Container = __webpack_require__(4023);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.14/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(9228);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(4309);
;// CONCATENATED MODULE: ./src/components/ui/InputGroup/style.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 0.9375rem;\n    margin-bottom: 0.9375rem;\n    color: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: transparent;\n    border: 1px solid #ded5d5;\n    transition: border 0.3s ease;\n    padding: 1.1875rem 0 1.1875rem 0.9375rem;\n    font-size: 1rem;\n    color: ",
        ";\n    &::placeholder {\n        opacity: 0.5;\n        transition: 0.3s ease;\n    }\n    &:hover,\n    &:focus {\n        border: 1px solid ",
        ";\n        &::placeholder {\n            padding-left: 20px;\n            opacity: 0;\n        }\n    }\n    @media (max-width: 768px) {\n        font-size: 0.9rem;\n    }\n    ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 30px;\n    textarea {\n        max-width: 100%;\n        min-height: 200px;\n    }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 5px;\n    font-weight: 500;\n    color: ",
        ";\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}

const Label = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-8232710e-0"
})(_templateObject(), (props)=>props.theme.palette.common.black);
const Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-8232710e-1"
})(_templateObject1(), (props)=>props.theme.palette.common.black, (props)=>props.theme.palette.primary.main, (props)=>props.error && "\n        border-color: ".concat(props.theme.palette.error.main, ";\n    "));
const InputGroupContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8232710e-2"
})(_templateObject2());
const Validation = styled_components_browser_esm/* default.small.withConfig */.ZP.small.withConfig({
    componentId: "sc-8232710e-3"
})(_templateObject3(), (props)=>props.theme.palette.error.main);

;// CONCATENATED MODULE: ./src/components/ui/InputGroup/index.tsx



const InputGroup = (props)=>{
    const { label , as , error , ...rest } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputGroupContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                as: as,
                error: error,
                ...rest
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Validation, {
                children: error
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/ui/SectionTitle/index.tsx + 1 modules
var SectionTitle = __webpack_require__(6227);
// EXTERNAL MODULE: ./node_modules/.pnpm/formik@2.2.9_react@18.2.0/node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(6301);
;// CONCATENATED MODULE: ./src/components/Contact/ContactForm/style.ts

function style_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 3rem;\n    margin-top: 5rem;\n    .container {\n        .button {\n            margin-left: auto;\n        }\n    }\n"
    ]);
    style_templateObject = function() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    background: ",
        ";\n    padding: 0.875rem;\n    margin-bottom: 1.375rem;\n    margin-top: 3.125rem;\n    display: flex;\n    align-items: center;\n"
    ]);
    style_templateObject1 = function() {
        return data;
    };
    return data;
}

const ContactSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-7c22cfb7-0"
})(style_templateObject());
const FormErrorMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7c22cfb7-1"
})(style_templateObject1(), (props)=>props.theme.palette.error.contrastText, (props)=>props.theme.palette.error.main);

// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(5423);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.3.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(5512);
;// CONCATENATED MODULE: ./src/graphql/queries.ts

function queries_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ($start: Int = 0) {\n        projects: ProjectSimplifiedCollection(start: $start) {\n            id\n            title\n            description\n            link\n            priority\n            upper_color\n            lower_color\n            showcase {\n                url\n            }\n            stack {\n                id\n                name\n                type\n                icon {\n                    url\n                }\n            }\n        }\n        technologies: TechnologySimplifiedCollection {\n            id\n            name\n            type\n            icon {\n                url\n            }\n        }\n    }\n"
    ]);
    queries_templateObject = function() {
        return data;
    };
    return data;
}
function queries_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation createMessage($name: String!, $email: String!, $message: String!) {\n        createMessage(data: { name: $name, email: $email, message: $message }) {\n            data {\n                attributes {\n                    name\n                    email\n                    message\n                }\n            }\n        }\n    }\n"
    ]);
    queries_templateObject1 = function() {
        return data;
    };
    return data;
}
function queries_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query {\n        meta: BlogSimplifiedCollection {\n            total\n        }\n    }\n"
    ]);
    queries_templateObject2 = function() {
        return data;
    };
    return data;
}
function queries_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ($start: Int, $limit: Int) {\n        blogsResponse: BlogSimplifiedCollection(start: $start, limit: $limit) {\n            highlighted {\n                id\n                title\n                slug\n                excerpt\n                created_at_formatted\n                categories {\n                    name\n                    color\n                    bgColor\n                }\n                cover {\n                    url\n                }\n            }\n            blogs {\n                id\n                title\n                slug\n                excerpt\n                created_at_formatted\n                categories {\n                    name\n                    color\n                    bgColor\n                }\n                cover {\n                    url\n                }\n            }\n            total\n        }\n    }\n"
    ]);
    queries_templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ($slug: String) {\n        blog: BlogSimplified(filters: { slug: { eq: $slug } }) {\n            id\n            title\n            body\n            minutes\n            createdAt\n            created_at_formatted\n            slug\n            cover {\n                url\n            }\n            categories {\n                name\n                color\n                bgColor\n            }\n            related {\n                title\n                slug\n                excerpt\n                cover {\n                    url\n                }\n            }\n        }\n    }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query {\n        blogs(pagination: { limit: 10000 }) {\n            data {\n                attributes {\n                    slug\n                }\n            }\n        }\n    }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}

const GET_PROJECTS_ALL_TECH = (0,lib/* gql */.Ps)(queries_templateObject());
const CREATE_MESSAGE = (0,lib/* gql */.Ps)(queries_templateObject1());
const GET_COUNT = (0,lib/* gql */.Ps)(queries_templateObject2());
const GET_BLOGS = (0,lib/* gql */.Ps)(queries_templateObject3());
const GET_SINGLE_BLOG = (0,lib/* gql */.Ps)(_templateObject4());
const GET_SLUGS = (0,lib/* gql */.Ps)(_templateObject5());

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.5_dfz4srh35q5kr6xt6bzy6ilpha/node_modules/@apollo/client/react/hooks/useMutation.js + 2 modules
var useMutation = __webpack_require__(4407);
// EXTERNAL MODULE: ./src/components/ui/Icons.tsx + 13 modules
var Icons = __webpack_require__(3508);
// EXTERNAL MODULE: ./src/components/ui/animations.ts
var animations = __webpack_require__(954);
;// CONCATENATED MODULE: ./src/components/ui/Alerts/style.ts

function Alerts_style_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        ",
        " 0.4s cubic-bezier(0.13, 0.18, 0.4, 1.37) forwards\n    "
    ]);
    Alerts_style_templateObject = function() {
        return data;
    };
    return data;
}
function Alerts_style_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: fixed;\n    bottom: 60px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: white;\n    width: 100%;\n    max-width: 300px;\n    box-shadow: 0px 0px 12px -6px rgba(24, 39, 75, 0.12),\n        0px 0 24px -4px rgba(24, 39, 75, 0.08);\n    background: white;\n    overflow: hidden;\n    animation: ",
        ";\n    font-size: 0.875rem;\n    color: black;\n    z-index: 2;\n    font-weight: 500;\n"
    ]);
    Alerts_style_templateObject1 = function() {
        return data;
    };
    return data;
}
function style_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            ",
        " 4s ease forwards 4s\n        "
    ]);
    style_templateObject2 = function() {
        return data;
    };
    return data;
}
function style_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n    height: 100%;\n    display: flex;\n    align-items: center;\n    padding: 0 0.9375rem;\n    &:after {\n        content: "";\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        height: 4px;\n        width: 100%;\n        background: #00a1ff;\n        width: 0;\n        animation: ',
        ";\n    }\n\n    svg {\n        path {\n            fill: #09a509;\n        }\n        margin-right: 0.875rem;\n    }\n\n    p {\n        margin: 0;\n    }\n"
    ]);
    style_templateObject3 = function() {
        return data;
    };
    return data;
}


const AlertElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f7580016-0"
})(Alerts_style_templateObject1(), (0,styled_components_browser_esm/* css */.iv)(Alerts_style_templateObject(), animations/* heightUp */.tb));
const AlertWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f7580016-1"
})(style_templateObject3(), (0,styled_components_browser_esm/* css */.iv)(style_templateObject2(), animations/* fillWidth */.Mx));

;// CONCATENATED MODULE: ./src/components/ui/Alerts/index.tsx




var AlertType;
(function(AlertType) {
    AlertType["Success"] = "success";
    AlertType["Error"] = "error";
})(AlertType || (AlertType = {}));
const Alert = (param)=>{
    let { type =AlertType.Success , title , text , setShowAlert  } = param;
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            setShowAlert(false);
        }, 8200);
    }, [
        setShowAlert
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertElement, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlertWrapper, {
            children: [
                type === AlertType.Success && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* RoundedFullCheck */.ag, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                            children: text
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Contact/ContactForm/index.tsx












const ContactForm = ()=>{
    const [showSuccessAlert, setShowSuccessAlert] = (0,react.useState)(false);
    const [formError, setFormError] = (0,react.useState)("");
    const initialValues = {
        name: "",
        email: "",
        message: ""
    };
    const validationSchema = es/* object */.Ry({
        name: es/* string */.Z_().required("Name is required"),
        email: es/* string */.Z_().email("Invalid email").required("Email is required"),
        message: es/* string */.Z_().required("Message is required")
    });
    const [createMessage] = (0,useMutation/* useMutation */.D)(CREATE_MESSAGE, {
        onCompleted () {
            setShowSuccessAlert(true);
            setFormError("");
        },
        onError (error) {
            setFormError(error.message);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactSection, {
        id: "contact",
        className: "body-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                        heading: "Let's Talk",
                        subHeading: "Contact"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                        initialValues: initialValues,
                        validationSchema: validationSchema,
                        onSubmit: async (values)=>{
                            await createMessage({
                                variables: {
                                    email: values.email,
                                    name: values.name,
                                    message: values.message
                                }
                            });
                        },
                        children: (param)=>/*#__PURE__*/ {
                            let { errors , touched , handleBlur , handleChange , values , isSubmitting  } = param;
                            return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                                children: [
                                    formError && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormErrorMessage, {
                                        children: formError
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGroup, {
                                        label: "Name",
                                        name: "name",
                                        as: formik_esm/* Field */.gN,
                                        placeholder: "What should i call you?, you can call me Zack",
                                        error: touched.name && errors.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGroup, {
                                        name: "email",
                                        label: "Email",
                                        as: formik_esm/* Field */.gN,
                                        placeholder: "Email to reach you",
                                        error: touched.email && errors.email
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGroup, {
                                        label: "Message",
                                        name: "message",
                                        as: "textarea",
                                        value: values.message,
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        placeholder: "Small description about your requirements",
                                        error: touched.message && errors.message
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        isLoading: isSubmitting,
                                        type: "submit",
                                        "aria-label": "submit",
                                        children: "Send"
                                    })
                                ]
                            });
                        }
                    })
                ]
            }),
            showSuccessAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                title: "Thank you for reaching out to me",
                text: "Expect a response within 1-4 days",
                setShowAlert: setShowSuccessAlert
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Index/FindMe/index.tsx + 1 modules
var FindMe = __webpack_require__(4154);
// EXTERNAL MODULE: ./src/components/SEO/index.tsx
var SEO = __webpack_require__(3194);
;// CONCATENATED MODULE: ./src/pages/contact.tsx




const Contact = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* HomeSeo */.i, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FindMe/* FindMe */.T, {})
        ]
    });
};
/* harmony default export */ var contact = (Contact);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [433,760,774,888,179], function() { return __webpack_exec__(2860); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);